import comp from "./WaveLoader";
export default comp;
